import React, {  useState } from 'react'
import {data} from './Data/Data.js'
import NavBar from "./NavBar";
import Hero from "./Hero";
import TopImages from "./TopImages";

function Food() {
    const [food,setFood] =useState(data);
    console.log(food);
    const[cat,setCat] = useState(0);

    const UpdateCat = ()=>{
        setCat(prevCat=>prevCat+1);
       
    }
 

    const FilterType =(category) => {
       setFood(
        data.filter((item)=>{
            return item.category === category;
      }))
    }

    const FilterPrice = (price)=>{
        setFood(
            data.filter((item)=>{
                return item.price === price;
            })
        )
    }
  return (
    <>
    <NavBar cat={cat}/>
    <Hero/>
    <TopImages/>
    <div className='max-w-[1640px] mx-auto px-4 py-12'>
        <h1 className='text-orange-600 font-bold text-4xl text-center'>
            Top Rated Menu Items</h1>
        {/* filter Row */}
        <div className='flex flex-col lg:flex-row  justify-between'>
             {/* Filter Type */}
         <div className='mt-3' >
            <p className='font-bold text-gray-800'>Filter Type</p>
           
            <div className='flex flex-wrap  justify-between'>
                <button onClick={()=>setFood(data)} className='border rounded-md px-4 ease-in-out duration-500  border-orange-600 text-orange-600 hover:bg-orange-600 hover:text-white m-2'>
                    All</button>
                <button onClick={()=>FilterType('burger')} className='border rounded-md px-4 ease-in-out duration-500  border-orange-600 text-orange-600 hover:bg-orange-600 hover:text-white m-2'>
                    Burgers</button>
                <button onClick={()=>FilterType('pizza')} className='border rounded-md px-4 ease-in-out duration-500  border-orange-600 text-orange-600 hover:bg-orange-600 hover:text-white m-2'>
                    Pizza</button>
                <button onClick={()=>FilterType('salad')}  className='border rounded-md px-4 ease-in-out duration-500  border-orange-600 text-orange-600 hover:bg-orange-600 hover:text-white m-2'>
                    Salads</button>
                <button onClick={()=>FilterType('chicken')}  className='border rounded-md px-4 ease-in-out duration-500  border-orange-600 text-orange-600 hover:bg-orange-600 hover:text-white m-2'>
                    Chickens</button>

            </div>
            </div>
            {/*Filter Price  */}
        <div className='mt-3'>
            <p className='font-bold text-gray-800'>Filter Price</p>
         <div className='flex w-full max-w-[390px] justify-between flex-wrap'>
            <button onClick={()=>FilterPrice('$')} className='border border-orange-600 px-4 rounded-md text-orange-600 m-2 hover:text-white hover:bg-orange-600 ease-in-out duration-500 '>$</button>
            <button onClick={()=>FilterPrice('$$')} className='border border-orange-600 px-4 rounded-md text-orange-600 m-2 hover:text-white hover:bg-orange-600 ease-in-out duration-500 '>$$</button>
            <button onClick={()=>FilterPrice('$$$')} className='border border-orange-600 px-4 rounded-md text-orange-600 m-2 hover:text-white hover:bg-orange-600 ease-in-out duration-500 '>$$$</button>
            <button onClick={()=>FilterPrice('$$$$')} className='border border-orange-600 px-4 rounded-md text-orange-600 m-2 hover:text-white hover:bg-orange-600 ease-in-out duration-500 '>$$$$</button>
         </div>
        </div>
    </div>
    {/* Display foods */}
    <div className='grid grid-cols-2 lg:grid-cols-4 pt-4  gap-6'>
        {
            food.map((item,index)=>(
                <div key={index} className='border shadow-[0_0_10px_theme(colors.orange.700)] hover:scale-105 duration-300 rounded-xl'>
                    <img className='object-cover w-full h-[230px] rounded-t-xl' src={item.image} alt={item.name} />
                    <div className='flex justify-between px-2 py-2 '>
                        <p className='font-bold max-w-[100px]'>{item.name}</p>
                        <p className='grid  sm:grid-cols-2 items-center' ><span className='bg-orange-500 text-white rounded-lg  px-1 text-center  cursor-pointer hover:bg-orange-600'>{item.price}</span><span onClick={UpdateCat} className='bg-orange-500 text-white rounded-lg  m-2 cursor-pointer hover:bg-orange-600 py-1 font-bold px-2'> Cart +</span></p>
                    </div>
                </div>
            ))
        }
    </div>

      
    </div>
      
    </>
    
  )
}

export default Food
